// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Account } from './account';
import { AccountTemplate } from './account-template';
import { Batch } from './batch';
import { CounterpartyDatum } from './counterparty-datum';
import { CreditorClaim } from './creditor-claim';
import { CustomProperty } from './custom-property';
import { CustomPropertyType } from './custom-property-type';
import { LookupList } from './lookup-list';
import { MeetingAttendanceResolution } from './meeting-attendance-resolution';
import { MeetingResolution } from './meeting-resolution';
import { MergeTemplate } from './merge-template';
import { MergeTemplateCategory } from './merge-template-category';
import { SearchOrder } from './search-order';
import { TaxCode } from './tax-code';
import { Transfer } from './transfer';
import { TransferWebRequest } from './transfer-web-request';
import { TransferWebResponse } from './transfer-web-response';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Lookup extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  lookupId!: number;
  createdBy!: string;
  createdDate!: Date;
  data?: string;
  description!: string;
  flag?: number;
  lookupListId!: number;
  tag?: string;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
  accountBfstatusLookups!: Account[];
  accountLookupId1Navigations!: Account[];
  accountLookupId2Navigations!: Account[];
  accountLookupId3Navigations!: Account[];
  accountTemplateLookupId1Navigations!: AccountTemplate[];
  accountTemplateLookupId2Navigations!: AccountTemplate[];
  accountTemplateLookupId3Navigations!: AccountTemplate[];
  batches!: Batch[];
  counterpartyData!: CounterpartyDatum[];
  creditorClaims!: CreditorClaim[];
  customProperties!: CustomProperty[];
  customPropertyTypes!: CustomPropertyType[];
  lookupList!: LookupList;
  meetingAttendanceResolutions!: MeetingAttendanceResolution[];
  meetingResolutions!: MeetingResolution[];
  mergeTemplateCategories!: MergeTemplateCategory[];
  mergeTemplates!: MergeTemplate[];
  searchOrderSearchProviderLookups!: SearchOrder[];
  searchOrderSearchStatusLookups!: SearchOrder[];
  searchOrderSearchTypeLookups!: SearchOrder[];
  taxCodes!: TaxCode[];
  transferWebRequests!: TransferWebRequest[];
  transferWebResponses!: TransferWebResponse[];
  transfers!: Transfer[];
}

